import { render, staticRenderFns } from "./lay-head.vue?vue&type=template&id=3f73bf9b&scoped=true"
import script from "./lay-head.vue?vue&type=script&lang=js"
export * from "./lay-head.vue?vue&type=script&lang=js"
import style0 from "./lay-head.vue?vue&type=style&index=0&id=3f73bf9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f73bf9b",
  null
  
)

export default component.exports